import script from "./CompareQuotes.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompareQuotes.vue?vue&type=script&lang=ts&setup=true"

import "./CompareQuotes.vue?vue&type=style&index=0&id=a16c761c&lang=css"

const __exports__ = script;

export default __exports__